import React from "react";
import UserIcon from "../../../../../../gd-ui/icon/user/user";
import FieldProto from "../../../../../proto/field-proto";
import FieldViewForUser_ControlViewEmpty from "./value-empty";

type Props = {
    className?  : string
    option      : Option
    field       : FieldProto
    disabled?   : boolean
    onClick     : callback
    onReset     : callback
    children    : any
}

export default function FieldViewForUser_ControlViewNotEmpty(props: Props) {

    const [showResetButton, setShowResetButton] = React.useState(false);

    const classes = Classes("ui5-control-button s-28 selected", props.className, {
        "disabled": props.disabled
    })

    if(props.option.value === gd.session.me.id){
        return <FieldViewForUser_ControlViewEmpty className = {props.className}
                                                  field     = {props.field}
                                                  disabled  = {props.disabled}
                                                  children  = {props.children}
                                                  onClick   = {props.onClick}/>
    }

    const onMouseEnter = ()=>{
        setShowResetButton(true)
    }

    const onMouseLeave = ()=>{
        setShowResetButton(false)
    }

    const onClick = ()=>{
        props.onClick(props.option.value)
    }

    const onReset = (e: React.SyntheticEvent)=>{
        e.stopPropagation()
        props.onReset()
    }


    return (
        <>
            <div className={classes} onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>

                <UserIcon className="m-r-8" userId={props.option.value} size="22"/>

                <div className="ui5-txt-not-important-small lh-13em">{props.option.label}</div>

                <div className="flex-row-right-center">

                    {!props.disabled && showResetButton &&
                        <div className="ui5-ico-delete s16 red m-l-5" onClick={onReset}/>
                    }

                    {!showResetButton && <div className="btn-arrow flex-row-center-center w-16 m-l-5"/>}

                </div>
            </div>

            {props.children}
        </>
    )
}
